import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { Activity } from 'types';

type PermitType = Activity['document_type'];

export type PermitChipProps = {
  type: PermitType;
  children: ReactNode;
};

const colorMap: Record<NonNullable<PermitType>, string> = {
  'Site Plan': '#E1D0A3',
  'Building Permit': '#BCCEE9',
  'Demolition Permit': '#BCCEE9',
  Rezoning: '#C0E4DE',
  'Electrical Permit': '#DAD4E8',
  'Tenancy Change': '#D2E8C5',
  'Business Licence': '#FAE4F1',
  'Municipal Hearing': '#FAE4F1',
  Entitlement: '#C0E4DE',
  'Land Title Change': '#F1CEB9',
  Plat: '#9ACDF2',
  'Mechanical Permit': '#D5D9C0',
  'Plumbing Permit': '#B1D8E8',
  'Accessibility Compliance': '#F8B19F',
  'Building Plan Review': '#DCE8C4',
  'Environmental Permit': '#DCE8C4',
};

const container = {
  padding: '0.15rem 0.5rem',
  fontSize: '13px',
  letterSpacing: '-0.01em',
  fontWeight: '600',
  borderRadius: 4,
  textAlign: 'center',
  display: 'inline-block',
};

export const PermitChip = ({ children, type }: PermitChipProps) => {
  const color = type ? colorMap[type] : 'gray.500';

  return (
    <Box bgColor={color} sx={container}>
      {children}
    </Box>
  );
};
